import ScrollWrapper from './ScrollWrapper.css';

export default ScrollWrapper;
